/**
 * Directive: scheduleRangeCreate
 */
angular.module('acme.common.directive.scheduleRangeCreate', [])
.directive('scheduleRangeCreate', [function() {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/scheduleRange/create/create.tpl.html',
      scope: {},
      
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', function($scope) {

        $scope.scheduleRangeCreate = "Your spankin new scheduleRange.create!";

      }]

    };

}]);